import { NotePencil } from "@phosphor-icons/react";
import { useScriptPanel } from "../../context/ScriptPanelContext";
import { useNateM, NATE_M_EXPANDED_WIDTH, NATE_M_MINIMIZED_WIDTH } from "../../context/NateMContext";

export function ScriptPanelLauncher() {
  const panelCtx = useScriptPanel();
  const { minimized } = useNateM();
  if (!panelCtx) return null;
  const nateMMargin = minimized ? NATE_M_MINIMIZED_WIDTH : NATE_M_EXPANDED_WIDTH;

  return (
    <button
      data-testid="script-panel-toggle-button"
      onClick={() => panelCtx.openScriptPanel(null, "funding")}
      style={{ right: nateMMargin + 32 }}
      title="Opens a step-by-step call script and objection-handling guide for talking to a lead."
      className="fixed bottom-8 z-40 flex items-center gap-2 px-5 h-14 rounded-full bg-igc-surface border border-igc-gold/40 text-igc-goldText shadow-2xl hover:-translate-y-0.5 hover:border-igc-gold transition-all"
    >
      <NotePencil size={20} weight="duotone" />
      <span className="text-sm font-medium">Scripts</span>
    </button>
  );
}
